import React from 'react';

import { Button } from '@mantine/core';

import { useModal } from '../ManagePackagesModal/Context/ModalContext';

const NoExpectationsMessage = (): JSX.Element => {
  const { openModal } = useModal();

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>No Packages Have Been Added to the Report</h2>
      <p>To see the behavior of athletes and packages, add packages to be tracked in the report.</p>
      <Button sx={{ marginTop: '1rem' }} onClick={() => openModal('register')}>
        Add Packages to Track
      </Button>
    </div>
  );
};

export default NoExpectationsMessage;
